export enum EnListControlType {
    List,
    User,
    Direct,
    None
}
